module.exports = "/images/viluu-appicon.svg?0ea935a9173069afcc261d3a902dd153";